/*
  Sportconic productpagina (Fase 1) — interacties.
  Bewust WEGGELATEN t.o.v. het oorspronkelijke ontwerp:
   - galerij-logica (selectThumb/changeThumb): Dawn's media-gallery doet dit nu;
   - prijs/variant/CTA-rekenwerk (basePrice/updateCTA, incl. de dubbele definitie-bug
     uit het origineel): de prijs komt uit Shopify en de model-keuze is een link naar
     het zusterproduct, dus daar is hier geen JS voor nodig.
  Alles staat in één IIFE zodat er niets in de globale scope lekt.
*/
(function () {
  function init() {
    /* Voorkom dubbel binden op dezelfde levende DOM (bijv. DOMContentLoaded +
       shopify:section:load kort na elkaar). Na een sectie-herlaad in de editor is
       .sportconic-product een NIEUW element zonder deze marker → init draait dan wel. */
    var spGuard = document.querySelector('.sportconic-product');
    if (spGuard) {
      if (spGuard.dataset.spInit === '1') return;
      spGuard.dataset.spInit = '1';
    }

    /* ── Sterren/score bij de titel → scroll naar het reviews-blok ── */
    var rrow = document.querySelector('.sportconic-product .reviews-row');
    if (rrow) {
      rrow.style.cursor = 'pointer';
      rrow.addEventListener('click', function () {
        var r = document.querySelector('.sp-reviews');
        if (r) r.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* ── Countdown ──
       Einddatum komt uit data-deal-end op .deal-timer (ISO-string, gezet via de
       sectie-instelling). Geen geldige/toekomstige datum? Dan laten we de statische
       waarde uit de HTML staan i.p.v. een timer die elke paginalaad reset. */
    var timer = document.querySelector('.sportconic-product .deal-timer[data-deal-end]');
    if (timer) {
      var endValue = timer.getAttribute('data-deal-end');
      var dealEnd;
      if (endValue === 'auto' || endValue === '') {
        // Rollende dagelijkse timer: telt af tot vanavond 23:59:59 (lokale tijd).
        dealEnd = new Date();
        dealEnd.setHours(23, 59, 59, 0);
        if (dealEnd.getTime() <= Date.now()) {
          dealEnd.setDate(dealEnd.getDate() + 1);
        }
      } else {
        dealEnd = new Date(endValue);
      }
      var segH = timer.querySelector('#dt-h');
      var segM = timer.querySelector('#dt-m');
      var segS = timer.querySelector('#dt-s');

      if (dealEnd && !isNaN(dealEnd.getTime()) && dealEnd.getTime() > Date.now() && segH && segM && segS) {
        var tick = function () {
          var diff = Math.max(0, dealEnd.getTime() - Date.now());
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var s = Math.floor((diff % 60000) / 1000);
          segH.textContent = String(h).padStart(2, '0');
          segM.textContent = String(m).padStart(2, '0');
          segS.textContent = String(s).padStart(2, '0');
          if (diff <= 0 && intervalId) {
            clearInterval(intervalId);
          }
        };
        tick();
        var intervalId = setInterval(tick, 1000);
      }
    }

    /* ── Accordeons ── */
    document.querySelectorAll('.sportconic-product .acc-head').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.acc-item');
        if (item) {
          var isOpen = item.classList.toggle('open');
          head.setAttribute('aria-expanded', String(isOpen));
        }
      });
    });

    /* ── Info-popover (model-verschil) ── */
    document.querySelectorAll('.sportconic-product .info-icon').forEach(function (icon) {
      icon.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = icon.classList.toggle('open');
        icon.setAttribute('aria-expanded', String(isOpen));
      });
    });
    document.addEventListener('click', function () {
      document.querySelectorAll('.sportconic-product .info-icon.open').forEach(function (el) {
        el.classList.remove('open');
        el.setAttribute('aria-expanded', 'false');
      });
    });

    /* ── UGC stories-slider ── */
    document.querySelectorAll('.sportconic-product .stories-section').forEach(function (section) {
      var track = section.querySelector('.stories-track');
      if (!track) return;
      var slide = function (dir) {
        var card = track.querySelector('.story-card');
        if (!card) return;
        var cardW = card.offsetWidth + 10;
        track.scrollBy({ left: dir * cardW, behavior: 'smooth' });
      };
      var buttons = section.querySelectorAll('.stories-nav button');
      if (buttons[0]) buttons[0].addEventListener('click', function () { slide(-1); });
      if (buttons[1]) buttons[1].addEventListener('click', function () { slide(1); });
    });

    /* ── Galerij + lightbox ── */
    var root = document.querySelector('.sportconic-product');
    if (root) {
      var mainImg = root.querySelector('#sp-mainImg');
      var thumbsWrap = root.querySelector('#sp-thumbs');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('#sp-thumbs .thumb'));
      var lbCounter = root.querySelector('#sp-lb-counter');
      var cur = 0;

      var scrollThumbIntoView = function (i) {
        if (!thumbsWrap) return;
        var t = thumbs[i];
        if (!t) return;
        var pad = 12;
        var peek = 44; // stukje van de buur-thumb dat zichtbaar blijft, zodat de volgende makkelijk te tikken is
        var viewLeft = thumbsWrap.scrollLeft;
        var viewRight = viewLeft + thumbsWrap.clientWidth;
        var nxt = thumbs[i + 1];
        var prv = thumbs[i - 1];
        // rechterdoel: rechterkant van de actieve thumb + een peek van de volgende thumb
        var rightTarget = nxt ? nxt.offsetLeft + Math.min(peek, nxt.offsetWidth) : t.offsetLeft + t.offsetWidth + pad;
        // linkerdoel: linkerkant van de actieve thumb - een peek van de vorige thumb
        var leftTarget = prv ? prv.offsetLeft + prv.offsetWidth - Math.min(peek, prv.offsetWidth) : t.offsetLeft - pad;
        if (rightTarget > viewRight) {
          thumbsWrap.scrollTo({ left: rightTarget - thumbsWrap.clientWidth, behavior: 'smooth' });
        } else if (leftTarget < viewLeft) {
          thumbsWrap.scrollTo({ left: leftTarget, behavior: 'smooth' });
        }
      };

      var pendingSrc = null;
      var show = function (i) {
        if (!thumbs.length) return;
        if (i < 0) i = thumbs.length - 1;
        if (i >= thumbs.length) i = 0;
        cur = i;
        if (lbCounter) lbCounter.textContent = (i + 1) + ' / ' + thumbs.length;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumbs[i].classList.add('active');
        scrollThumbIntoView(i);
        if (mainImg) {
          var src = thumbs[i].getAttribute('data-img');
          pendingSrc = src;
          var preload = new Image();
          preload.onload = preload.onerror = function () {
            if (pendingSrc !== src) return; // nieuwere show() gewonnen
            mainImg.style.opacity = '0';
            /* srcset weghalen: die wint van src, waardoor de galerij niet
               wisselde. Alleen de eerste (LCP-)afbeelding heeft een srcset. */
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = src;
            mainImg.style.opacity = '1';
          };
          preload.src = src;
        }
      };

      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var gprev = root.querySelector('.sp-gal-prev');
      var gnext = root.querySelector('.sp-gal-next');
      if (gprev) gprev.addEventListener('click', function () { show(cur - 1); });
      if (gnext) gnext.addEventListener('click', function () { show(cur + 1); });

      /* Prefetch alle galerij-foto's (width 1000) op de achtergrond, zodat het wisselen
         van foto instant is. Via requestIdleCallback zodat het de eerste paginalading
         niet vertraagt. Referenties vasthouden tegen garbage collection. */
      var _spGalleryPrefetch = [];
      var prefetchGallery = function () {
        thumbs.forEach(function (t) {
          var u = t.getAttribute('data-img');
          if (!u) return;
          var im = new Image();
          im.decoding = 'async';
          im.src = u;
          _spGalleryPrefetch.push(im);
        });
      };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(prefetchGallery, { timeout: 2000 });
      } else {
        window.addEventListener('load', prefetchGallery);
      }

      /* ── Vegen op de hoofdfoto (mobiel): links = volgende, rechts = vorige ── */
      var galMain = root.querySelector('.gallery-main');
      var swipeJustHappened = false;
      if (galMain) {
        var tStartX = 0, tStartY = 0;
        galMain.addEventListener('touchstart', function (e) {
          tStartX = e.changedTouches[0].clientX;
          tStartY = e.changedTouches[0].clientY;
        }, { passive: true });
        galMain.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - tStartX;
          var dy = e.changedTouches[0].clientY - tStartY;
          // Alleen reageren op een duidelijke horizontale veeg (niet op verticaal scrollen).
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            swipeJustHappened = true;
            if (dx < 0) { show(cur + 1); } else { show(cur - 1); }
            setTimeout(function () { swipeJustHappened = false; }, 350);
          }
        }, { passive: true });
      }

      var lb = root.querySelector('#sp-lightbox');
      if (lb) {
        var lbImg = lb.querySelector('#sp-lb-img');
        var fullSrc = function () {
          if (thumbs.length) return thumbs[cur].getAttribute('data-full');
          return mainImg ? mainImg.getAttribute('src') : '';
        };

        // ── Zoom-status (pinch-zoom op de foto) ──
        var lbScale = 1, lbTx = 0, lbTy = 0;
        var applyTransform = function () {
          if (lbImg) lbImg.style.transform = 'translate(' + lbTx + 'px,' + lbTy + 'px) scale(' + lbScale + ')';
        };
        var clampPan = function () {
          if (!lbImg) return;
          var maxX = Math.max(0, (lbImg.offsetWidth * lbScale - window.innerWidth) / 2);
          var maxY = Math.max(0, (lbImg.offsetHeight * lbScale - window.innerHeight) / 2);
          lbTx = Math.max(-maxX, Math.min(maxX, lbTx));
          lbTy = Math.max(-maxY, Math.min(maxY, lbTy));
        };
        var resetZoom = function (animate) {
          lbScale = 1; lbTx = 0; lbTy = 0;
          if (!lbImg) return;
          lbImg.style.transition = animate ? 'transform 0.2s ease' : 'none';
          applyTransform();
          if (animate) setTimeout(function () { if (lbImg) lbImg.style.transition = 'none'; }, 220);
        };
        // Toont thumbnail meteen (al gecacht), laadt volle resolutie op achtergrond.
        var lbFullLoad = null;
        var showLbImg = function () {
          var thumbUrl = thumbs[cur] ? thumbs[cur].getAttribute('data-img') : fullSrc();
          var fullUrl = fullSrc();
          if (lbImg) lbImg.src = thumbUrl;
          if (lbFullLoad) { lbFullLoad.onload = null; }
          lbFullLoad = new Image();
          lbFullLoad.onload = function () { if (lbImg && lbImg.src !== fullUrl) lbImg.src = fullUrl; };
          lbFullLoad.src = fullUrl;
        };
        var navLb = function (delta) {
          show(cur + delta);
          showLbImg();
          resetZoom(false);
        };
        var lockedScrollY = 0;
        var openLb = function () {
          showLbImg();
          resetZoom(false);
          if (lbCounter) lbCounter.textContent = (cur + 1) + ' / ' + thumbs.length;
          lb.classList.add('open');
          // Achtergrond vastzetten (betrouwbaar op iOS): body fixeren op huidige scrollpositie.
          lockedScrollY = window.scrollY || window.pageYOffset || 0;
          document.body.style.position = 'fixed';
          document.body.style.top = '-' + lockedScrollY + 'px';
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.width = '100%';
        };
        var closeLb = function () {
          lb.classList.remove('open');
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.left = '';
          document.body.style.right = '';
          document.body.style.width = '';
          window.scrollTo(0, lockedScrollY); // terug naar waar je was
        };
        var main = root.querySelector('.gallery-main');
        if (main) main.addEventListener('click', function (e) {
          if (e.target.closest('.gallery-nav')) return;
          if (swipeJustHappened) return; // net geveegd → niet de lightbox openen
          openLb();
        });
        if (main) main.addEventListener('keydown', function (e) {
          if (e.target !== main) return; // Enter/Space op de prev/next-knoppen zelf negeren, die hebben hun eigen click
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(); }
        });
        var lbClose = lb.querySelector('.lb-close');
        if (lbClose) lbClose.addEventListener('click', closeLb);
        lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
        var lbp = lb.querySelector('.sp-lb-prev');
        var lbn = lb.querySelector('.sp-lb-next');
        if (lbp) lbp.addEventListener('click', function () { navLb(-1); });
        if (lbn) lbn.addEventListener('click', function () { navLb(1); });
        document.addEventListener('keydown', function (e) {
          if (!lb.classList.contains('open')) return;
          if (e.key === 'Escape') closeLb();
          if (e.key === 'ArrowRight') navLb(1);
          if (e.key === 'ArrowLeft') navLb(-1);
        });

        /* ── Gebaren in de lightbox: knijpen = zoomen, slepen = verschuiven (gezoomd),
              vegen = wisselen/sluiten (alleen niet-gezoomd). Achtergrond beweegt nooit mee. ── */
        var gMode = null; // 'pinch' | 'pan' | 'swipe'
        var pinchStartDist = 0, pinchStartScale = 1, prevMidX = 0, prevMidY = 0;
        var dragStartX = 0, dragStartY = 0, dragBaseTx = 0, dragBaseTy = 0;
        var swStartX = 0, swStartY = 0;
        var touchDist = function (t) {
          var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
          return Math.sqrt(dx * dx + dy * dy);
        };
        lb.addEventListener('touchstart', function (e) {
          if (lbImg) lbImg.style.transition = 'none';
          if (e.touches.length === 2) {
            gMode = 'pinch';
            pinchStartDist = touchDist(e.touches);
            pinchStartScale = lbScale;
            prevMidX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
            prevMidY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
          } else if (e.touches.length === 1) {
            if (lbScale > 1) {
              gMode = 'pan';
              dragStartX = e.touches[0].clientX; dragStartY = e.touches[0].clientY;
              dragBaseTx = lbTx; dragBaseTy = lbTy;
            } else {
              gMode = 'swipe';
              swStartX = e.touches[0].clientX; swStartY = e.touches[0].clientY;
            }
          }
        }, { passive: true });
        lb.addEventListener('touchmove', function (e) {
          e.preventDefault(); // achtergrond beweegt nooit mee
          if (gMode === 'pinch' && e.touches.length === 2) {
            var mx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
            var my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
            var s1 = Math.max(1, Math.min(4, pinchStartScale * (touchDist(e.touches) / (pinchStartDist || 1))));
            var s0 = lbScale || 1;
            // Zoom rond het knijp-middelpunt: houd het punt onder je vingers op z'n plek.
            if (s1 !== s0) {
              var kx = mx - window.innerWidth / 2;
              var ky = my - window.innerHeight / 2;
              lbTx = kx * (1 - s1 / s0) + (s1 / s0) * lbTx;
              lbTy = ky * (1 - s1 / s0) + (s1 / s0) * lbTy;
              lbScale = s1;
            }
            // Twee vingers verschuiven = mee-pannen.
            lbTx += mx - prevMidX;
            lbTy += my - prevMidY;
            prevMidX = mx; prevMidY = my;
            clampPan();
            applyTransform();
          } else if (gMode === 'pan' && e.touches.length === 1) {
            lbTx = dragBaseTx + (e.touches[0].clientX - dragStartX);
            lbTy = dragBaseTy + (e.touches[0].clientY - dragStartY);
            clampPan();
            applyTransform();
          }
        }, { passive: false });
        lb.addEventListener('touchend', function (e) {
          if (gMode === 'pinch') {
            if (lbScale <= 1.05) resetZoom(true);
            gMode = null;
            return;
          }
          if (gMode === 'swipe' && e.changedTouches.length) {
            var dx = e.changedTouches[0].clientX - swStartX;
            var dy = e.changedTouches[0].clientY - swStartY;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
              navLb(dx < 0 ? 1 : -1);
            } else if (dy > 80 && Math.abs(dy) > Math.abs(dx) * 1.5) {
              closeLb();
            }
          }
          gMode = null;
        }, { passive: false });
      }

      /* ── Story-speler (klik op een reel = groot mét geluid, met vorige/volgende) ── */
      var storyVids = Array.prototype.slice.call(root.querySelectorAll('.stories-track .story-card video.story-bg'));
      var storyViewer = root.querySelector('#sp-story-viewer');
      if (storyViewer && storyVids.length) {
        var sVideo = storyViewer.querySelector('#sp-story-video');
        var sIdx = 0;
        var srcOf = function (v) { var s = v.querySelector('source'); return s ? s.getAttribute('src') : ''; };
        var showStory = function (i) {
          if (i < 0) i = storyVids.length - 1;
          if (i >= storyVids.length) i = 0;
          sIdx = i;
          sVideo.pause();
          sVideo.removeAttribute('src');
          sVideo.load();
          sVideo.src = srcOf(storyVids[i]);
          sVideo.muted = false;
          sVideo.currentTime = 0;
          var p = sVideo.play();
          if (p && p.catch) p.catch(function () {
            sVideo.muted = true;
            sVideo.play().catch(function () {});
          });
        };
        var closeStory = function () { storyViewer.classList.remove('open'); sVideo.pause(); };
        storyVids.forEach(function (v, i) {
          var card = v.closest('.story-card');
          if (!card) return;
          card.style.cursor = 'pointer';
          var openStory = function () { storyViewer.classList.add('open'); showStory(i); };
          card.addEventListener('click', openStory);
          card.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openStory(); }
          });
        });
        var sClose = storyViewer.querySelector('.sp-story-close');
        if (sClose) sClose.addEventListener('click', closeStory);
        storyViewer.addEventListener('click', function (e) { if (e.target === storyViewer) closeStory(); });
        var sPrev = storyViewer.querySelector('.sp-story-prev');
        var sNext = storyViewer.querySelector('.sp-story-next');
        if (sPrev) sPrev.addEventListener('click', function () { showStory(sIdx - 1); });
        if (sNext) sNext.addEventListener('click', function () { showStory(sIdx + 1); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && storyViewer.classList.contains('open')) closeStory(); });
      }

      /* ── Info-pop-up voor de gratis accessoires ── */
      var infoModal = root.querySelector('#sp-info-modal');
      if (infoModal) {
        document.body.appendChild(infoModal); // uit .sportconic-product → geen clipping/stacking-problemen (o.a. desktop)
        var infoImg = infoModal.querySelector('#sp-info-img');
        var infoImgWrap = infoModal.querySelector('.sp-info-img');
        var infoTitle = infoModal.querySelector('#sp-info-title');
        var infoText = infoModal.querySelector('#sp-info-text');
        var infoLockY = 0;
        var openInfo = function (btn) {
          if (infoTitle) infoTitle.textContent = btn.getAttribute('data-info-title') || '';
          if (infoText) infoText.textContent = btn.getAttribute('data-info-text') || '';
          var img = btn.getAttribute('data-info-img');
          if (infoImgWrap) {
            if (img) { infoImg.src = img; infoImgWrap.style.display = ''; }
            else { infoImgWrap.style.display = 'none'; }
          }
          infoModal.classList.add('open');
          infoLockY = window.scrollY || window.pageYOffset || 0;
          document.body.style.position = 'fixed';
          document.body.style.top = '-' + infoLockY + 'px';
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.width = '100%';
        };
        var closeInfo = function () {
          if (!infoModal.classList.contains('open')) return;
          infoModal.classList.remove('open');
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.left = '';
          document.body.style.right = '';
          document.body.style.width = '';
          window.scrollTo(0, infoLockY);
        };
        Array.prototype.slice.call(root.querySelectorAll('.addon-info-btn')).forEach(function (b) {
          b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openInfo(b); });
        });
        var infoCloseBtn = infoModal.querySelector('.sp-info-close');
        if (infoCloseBtn) infoCloseBtn.addEventListener('click', closeInfo);
        infoModal.addEventListener('click', function (e) { if (e.target === infoModal) closeInfo(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeInfo(); });
      }

      /* ── Sticky koopbalk (mobiel): tonen zodra de echte koopknop BOVEN de viewport
         uit beeld is gescrold; klik = klik op de echte knop (zelfde flow). ── */
      var stickyBar = document.getElementById('sp-sticky-atc');
      var stickyTarget = root.querySelector('.product-form__submit');
      if (stickyBar && stickyTarget && 'IntersectionObserver' in window) {
        var stickyBtn = stickyBar.querySelector('.sp-sticky-atc__btn');
        stickyBtn.addEventListener('click', function () {
          stickyTarget.click();
        });
        /* Spinner op de sticky knop: spiegel de 'loading'-status van de echte koopknop
           (die wordt gezet door Dawn's product-form én door onze eigen add-flow). */
        if ('MutationObserver' in window) {
          new MutationObserver(function () {
            stickyBtn.classList.toggle('is-loading', stickyTarget.classList.contains('loading'));
          }).observe(stickyTarget, { attributes: true, attributeFilter: ['class'] });
        }
        var stickyIO = new IntersectionObserver(function (entries) {
          var en = entries[0];
          var voorbij = !en.isIntersecting && en.boundingClientRect.bottom < 0;
          stickyBar.classList.toggle('is-visible', voorbij);
          if ('inert' in stickyBar) stickyBar.inert = !voorbij; // buiten tabvolgorde als verborgen
        });
        stickyIO.observe(stickyTarget);
      }

      /* ── Add-ons ──
         Gratis items (data-free): vast inbegrepen, gaan bij de koopknop in één cart-add mee.
         Betaalde toevoegingen: de schakelaar werkt DIRECT op de winkelwagen — aanzetten voegt
         het product meteen toe en opent de drawer; uitzetten haalt het er weer uit. */
      /* ── Prijs op de koopknop — voor ÁLLE producten, ook zonder addon-blokken.
         (Stond eerst binnen het addon-blok, waardoor T140/T155/P106 geen prijs toonden.) ── */
      var baseEl = root.hasAttribute('data-base-price') ? root : root.querySelector('[data-base-price]');
      var basePrice = baseEl ? (parseInt(baseEl.getAttribute('data-base-price'), 10) || 0) : 0;
      var submitBtn = root.querySelector('.product-form__submit');
      /* Valuta-bewust (Markets): actieve munt uit Shopify.currency, notatie via
         de paginataal. Terugval op € als Intl of Shopify.currency ontbreekt. */
      var fmtMoney = function (cents) {
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        var opts = { style: 'currency', currency: cur };
        if (cur === 'SEK') {
          opts.minimumFractionDigits = 0;
          opts.maximumFractionDigits = 0;
        }
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'nl', opts).format(cents / 100);
        } catch (e) {
          return '€' + (cents / 100).toFixed(2).replace('.', ',');
        }
      };
      var totalSpan = null;
      if (submitBtn && !submitBtn.disabled && basePrice > 0) {
        totalSpan = document.createElement('span');
        totalSpan.className = 'sp-cta-total';
        /* CTA toont alleen het hoofdproduct; betaalde toevoegingen zitten al in de wagen. */
        totalSpan.textContent = ' ' + fmtMoney(basePrice);
        submitBtn.appendChild(totalSpan);
      }

      /* ── Variant-kiezer ──
         Kaarten uit het variant_kiezer-blok. Bij een keuze verandert alleen wat er op de
         pagina van afhangt: het verborgen variant-veld in het koopformulier, de prijsregel,
         het Klarna-bedrag, de prijs op de koopknop en de grote foto. De prijs-HTML komt
         server-side uit Liquid mee, zodat de notatie per valuta klopt zonder die hier na
         te bouwen. De URL krijgt ?variant=… mee, zodat delen en verversen dezelfde keuze
         opleveren. */
      var variantKaarten = Array.prototype.slice.call(root.querySelectorAll('[data-variant-kaart]'));
      if (variantKaarten.length > 1) {
        var vkKiesVariant = function (kaart) {
          if (!kaart || kaart.classList.contains('active')) return;

          variantKaarten.forEach(function (k) {
            var actief = k === kaart;
            k.classList.toggle('active', actief);
            k.setAttribute('aria-pressed', actief ? 'true' : 'false');
          });

          var id = kaart.getAttribute('data-variant-id');
          var prijs = parseInt(kaart.getAttribute('data-variant-prijs'), 10) || 0;
          var beschikbaar = kaart.getAttribute('data-variant-beschikbaar') === '1';

          /* Koopformulier(en): ook de sticky balk op mobiel heeft er een. */
          root.querySelectorAll('.product-variant-id').forEach(function (veld) {
            veld.value = id;
          });

          /* Prijsregel en Klarna-bedrag. */
          var prijsRij = root.querySelector('.price-row');
          var prijsHtml = kaart.getAttribute('data-variant-prijs-html');
          if (prijsRij && prijsHtml) prijsRij.innerHTML = prijsHtml;
          var klarnaBedrag = root.querySelector('.klarna-line b');
          var klarna = kaart.getAttribute('data-variant-klarna');
          if (klarnaBedrag && klarna) klarnaBedrag.textContent = klarna;

          /* Prijs op de koopknop; basePrice wordt hierboven ook door de add-ons gebruikt. */
          basePrice = prijs;
          if (baseEl) baseEl.setAttribute('data-base-price', String(prijs));
          if (totalSpan && prijs > 0) totalSpan.textContent = ' ' + fmtMoney(prijs);

          /* Uitverkochte variant: koopknop blokkeren zolang die keuze aanstaat. */
          if (submitBtn) {
            submitBtn.disabled = !beschikbaar;
            submitBtn.classList.toggle('is-uitverkocht', !beschikbaar);
          }

          /* Sticky koopbalk op mobiel toont dezelfde prijs en foto. */
          var stickyPrijs = root.querySelector('.sp-sticky-atc__price');
          var kortePrijs = kaart.getAttribute('data-variant-prijs-kort');
          if (stickyPrijs && kortePrijs) stickyPrijs.textContent = kortePrijs;
          var stickyThumb = root.querySelector('.sp-sticky-atc__thumb img');
          var thumbUrl = kaart.getAttribute('data-variant-thumb');
          if (stickyThumb && thumbUrl) {
            stickyThumb.removeAttribute('srcset');
            stickyThumb.src = thumbUrl;
          }

          /* Grote foto meespringen naar de foto van deze variant. */
          var mediaIndex = parseInt(kaart.getAttribute('data-variant-media'), 10);
          if (!isNaN(mediaIndex) && mediaIndex >= 0) show(mediaIndex);

          /* Keuze in de URL, zonder de pagina te herladen. */
          if (window.history && history.replaceState) {
            try {
              var u = new URL(window.location.href);
              u.searchParams.set('variant', id);
              history.replaceState({}, '', u);
            } catch (e) {}
          }
        };

        variantKaarten.forEach(function (kaart) {
          kaart.addEventListener('click', function () { vkKiesVariant(kaart); });
        });
      }

      var addonRows = Array.prototype.slice.call(root.querySelectorAll('.addon[data-addon]'));
      if (addonRows.length) {

        var cartRootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
        var drawerSectionIds = function () {
          var drawer = document.querySelector('cart-drawer');
          return drawer && typeof drawer.getSectionsToRender === 'function'
            ? drawer.getSectionsToRender().map(function (s) { return s.id; })
            : ['cart-drawer', 'cart-icon-bubble'];
        };
        var refreshDrawer = function (data) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data); // rendert én opent de drawer
          }
        };
        /* Drawer-inhoud + teller verversen ZONDER de drawer te openen (zelfde
           sectie-vervanging als Dawn's renderContents, maar zonder open()).
           Gebruikt bij het úítzetten van een toevoeging. */
        var updateDrawerSilent = function (data) {
          var drawer = document.querySelector('cart-drawer');
          if (!drawer || !data || !data.sections || typeof drawer.getSectionsToRender !== 'function') return;
          drawer.getSectionsToRender().forEach(function (section) {
            var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            var html = data.sections[section.id];
            if (!target || !html) return;
            var src = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
            if (src) target.innerHTML = src.innerHTML;
          });
          if (typeof data.item_count === 'number') drawer.classList.toggle('is-empty', data.item_count === 0);
        };
        var setAddonVisual = function (a, isActive) {
          a.classList.toggle('active', isActive);
          var tg = a.querySelector('.toggle');
          if (tg) tg.classList.toggle('off', !isActive);
          if (a.hasAttribute('role')) a.setAttribute('aria-checked', String(isActive));
        };

        addonRows.forEach(function (a) {
          if (a.hasAttribute('data-free')) return; // gratis items zijn vast inbegrepen, niet aan/uit te zetten
          var busy = false;
          var toggleAddon = function () {
            if (busy) return;
            busy = true;
            a.style.opacity = '0.6';
            var done = function () { busy = false; a.style.opacity = ''; };
            var vid = a.getAttribute('data-variant-id');
            if (!a.classList.contains('active')) {
              /* Aanzetten → direct toevoegen aan de winkelwagen + drawer openen */
              fetch(cartRootUrl + 'cart/add.js', {
                method: 'POST',
                headers: jsonHeaders,
                body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: drawerSectionIds(), sections_url: window.location.pathname })
              })
                .then(function (r) { return r.json(); })
                .then(function (data) {
                  if (data && data.status) { done(); return; } // Shopify-foutmelding → toestand niet wijzigen
                  setAddonVisual(a, true);
                  refreshDrawer(data);
                  done();
                })
                .catch(done);
            } else {
              /* Uitzetten → de regel uit de winkelwagen halen */
              fetch(cartRootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  var line = null;
                  (cart.items || []).forEach(function (i) {
                    if (String(i.variant_id) === String(vid) && !(i.properties && i.properties._gift)) line = i;
                  });
                  if (!line) { setAddonVisual(a, false); done(); return; }
                  return fetch(cartRootUrl + 'cart/change.js', {
                    method: 'POST',
                    headers: jsonHeaders,
                    body: JSON.stringify({ id: line.key, quantity: 0, sections: drawerSectionIds(), sections_url: window.location.pathname })
                  })
                    .then(function (r) { return r.json(); })
                    .then(function (data) { setAddonVisual(a, false); updateDrawerSilent(data); done(); });
                })
                .catch(done);
            }
          };
          a.addEventListener('click', toggleAddon);
          a.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleAddon(); }
          });
        });

        /* Begintoestand: schakelaar aan wanneer de toevoeging al in de wagen zit. */
        var paidRows = addonRows.filter(function (a) { return !a.hasAttribute('data-free'); });
        if (paidRows.length) {
          fetch(cartRootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              paidRows.forEach(function (a) {
                var vid = a.getAttribute('data-variant-id');
                var inCart = (cart.items || []).some(function (i) { return String(i.variant_id) === String(vid) && !(i.properties && i.properties._gift); });
                setAddonVisual(a, inCart);
              });
            })
            .catch(function () {});
        }

        var form = root.querySelector('form[data-type="add-to-cart-form"]');
        if (form) {
          var spinner = form.querySelector('.loading__spinner');
          var setSubmitLoading = function (isLoading) {
            if (submitBtn) {
              if (isLoading) submitBtn.setAttribute('aria-disabled', 'true');
              else submitBtn.removeAttribute('aria-disabled');
              submitBtn.classList.toggle('loading', isLoading);
            }
            if (spinner) spinner.classList.toggle('hidden', !isLoading);
          };
          /* Op 'root' (voorouder van <product-form>) in de CAPTURE-fase i.p.v. op 'form' zelf:
             Dawn's product-form.js hangt zijn eigen submit-handler al op het form-element (bubble-fase)
             ZODRA de custom-element upgrade draait — dat is vóór DOMContentLoaded, dus vóór deze listener
             hier bestond. Op hetzelfde knooppunt vuren listeners in registratievolgorde, ongeacht de
             capture-vlag; Dawn's handler zou dus altijd eerst gaan en al zijn eigen cart/add.js-fetch
             starten (dubbele toevoeging) vóórdat stopImmediatePropagation() hier iets kon tegenhouden.
             Door hier op een voorouder te luisteren én stopPropagation() in de capture-fase aan te roepen,
             bereikt het event het form-knooppunt nooit en vuurt Dawn's handler helemaal niet. */
          root.addEventListener('submit', function (e) {
            if (e.target !== form) return;
            /* Alleen gratis items bundelen: betaalde toevoegingen staan al in de wagen
               (de schakelaar voegt ze direct toe) en zouden anders dubbel gaan. */
            var actives = addonRows.filter(function (a) { return a.classList.contains('active') && a.hasAttribute('data-free'); });
            if (!actives.length) return; // geen add-ons → Dawn handelt het normaal af
            var mainInput = form.querySelector('.product-variant-id');
            if (!mainInput || !mainInput.value) return;
            e.preventDefault();
            e.stopPropagation();
            setSubmitLoading(true);
            var items = [{ id: mainInput.value, quantity: 1 }];
            actives.forEach(function (a) {
              var li = { id: a.getAttribute('data-variant-id'), quantity: 1 };
              if (a.hasAttribute('data-free')) { li.properties = { _gift: 'true' }; } // markeer gratis cadeau → cart-drawer groepeert deze
              items.push(li);
            });
            var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
            var drawer = document.querySelector('cart-drawer');
            var sectionIds = drawer && typeof drawer.getSectionsToRender === 'function'
              ? drawer.getSectionsToRender().map(function (s) { return s.id; })
              : ['cart-drawer', 'cart-icon-bubble'];
            fetch(rootUrl + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items, sections: sectionIds, sections_url: window.location.pathname })
            })
              .then(function (r) { return r.json(); })
              .then(function (data) {
                if (data && data.status) { setSubmitLoading(false); window.location.href = rootUrl + 'cart'; return; } // Shopify-foutmelding
                if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
                  drawer.classList.remove('is-empty'); // wagen was leeg → anders blijft de lege-staat-layout hangen
                  drawer.renderContents(data); // rendert én opent de drawer
                  setSubmitLoading(false);
                } else {
                  window.location.href = rootUrl + 'cart';
                }
              })
              .catch(function () { setSubmitLoading(false); form.submit(); });
          }, true);
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme-editor: bij het herladen van een sectie vervangt Shopify de hele DOM van
     die sectie, waardoor alle listeners (toggles, galerij, cart-koppeling) verdwijnen.
     Opnieuw initialiseren — de verse .sportconic-product heeft geen spInit-marker,
     dus de guard hierboven laat de her-init door. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.sportconic-product')) init();
  });
})();
